module.exports = __webpack_public_path__ + "img/yjzkxcx.5b4a5125.jpg";